import React from "react";
import { render } from "react-dom";
import App from "./modules/App";
import NotFound from "./modules/NotFound";
import { Router, Route, browserHistory } from "react-router";
import {
  Dstv,
  Gotv,
  Phcn,
  Transfer,
  Airtime,
  VgcWater,
  DemoSchool,
  JungleJustice
} from "./modules/routes/Routes";

import "./normalize.css";
import "./index.css";

render(
  <Router history={browserHistory}>
    <Route path="/" component={App} />
    <Route path="/dstv" component={Dstv} />
    <Route path="/gotv" component={Gotv} />
    <Route path="/phcn" component={Phcn} />
    <Route path="/transfer" component={Transfer} />
    <Route path="/airtime" component={Airtime} />
    <Route path="/vgcwater" component={VgcWater} />
    <Route path="/demoschool" component={DemoSchool} />
    <Route path="/junglejustice" component={JungleJustice} />
    <Route path="*" component={NotFound} />
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js